import { apiClient } from '../../utils';
import { handleError } from '../';

export const removeTile = async ({ siteId, tileCollectionId }) => {
  try {
    const { result } = await apiClient.post('/merchant/slider/remove', {
      data: { site: siteId, slider: tileCollectionId },
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
